import React, { useEffect } from "react";

const Modal = ({
  open,
  onClose,
  children,
  width = 760,
  ariaLabel,
  closeOnBackdrop = true,
  gutter = 20,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel}
      onClick={closeOnBackdrop ? onClose : undefined}
      style={{
        position: "fixed",
        // Explicit offsets instead of `inset: 0` — the shorthand is unsupported
        // on old Sunmi/Android WebViews, which left the backdrop/dialog
        // mispositioned. Longhand works everywhere; identical on modern browsers.
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1600,
        background: "rgba(15,17,21,0.52)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: gutter,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "var(--qv-bg-ffffff, #fff)",
          borderRadius: 16,
          width,
          maxWidth: "100%",
          boxShadow: "0 24px 60px -12px var(--qv-shadow-a15x17x21x350, rgba(15,17,21,0.35))",
          display: "flex",
          flexDirection: "column",
          maxHeight: `calc(100vh - ${gutter * 2}px)`,
          position: "relative",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
